
<div class="card shadow p-3 bg-white rounded">
  <div class="row align-items-center text-center">
    <div class="col-md-12">
      <div class="card-body">
        <img src="assets/images/IFSLogo.png" alt="" class="auth-logo mb-4">
        <h4 class="mb-3 f-w-400">Sign in</h4>
        <div *ngIf="errorMessageList.length > 0" class="alert alert-danger">

          <div *ngFor="let errorMessage of errorMessageList">{{errorMessage}}</div>

        </div>
        <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">

          <div class="input-group mb-3">
            <span class="input-group-text"><i class="feather icon-mail"></i></span>
            <input type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.username.errors }" placeholder="Username" noUnsafeSpecial />
            <div style="float:left;width:100%" *ngIf="submitted &amp;&amp; registerForm.controls.username.errors" class="text-danger">
              <div *ngIf="registerForm.controls.username.errors.required">Username is required</div>
            </div>
          </div>

          <div class="input-group mb-3">
            <span class="input-group-text"><i class="feather icon-lock"></i></span>
            <input #passwordInput type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.password.errors }" placeholder="Password" />
            <div style="float:left;width:100%" *ngIf="submitted &amp;&amp; registerForm.controls.password.errors" class="text-danger">
              <div *ngIf="registerForm.controls.password.errors.required">Password is required</div>
            </div>
          </div>

          <button class="btn btn-block btn-primary mb-4">Sign in</button>

        </form>
      </div>


    </div>

  </div>
</div>

